module.exports = __webpack_public_path__ + "img/icon-visa.237a6949.svg";